<template>
  <v-card>
    <v-row no-gutters class="px-5">
      <div class="headline font-weight-bold ml-2">
        <!-- <translate>Language</translate> -->
      </div>
      <v-radio-group
        v-model="languageDefault"
        row
        class="mt-5"
        style="width: 100%"
      >
        <v-radio
          class="col pa-0"
          :class="[column ? 'col-12' : 'col-md-4 col-12']"
          color="success"
          :value="language.id"
          v-for="language in golfVlogLanguage.slice(0, 5)"
          :key="language.id"
          @change="chooseLanguage(language.id)"
          style="height: fit-content"
        >
          <template v-slot:label>
            <div class="black--text text-subtitle-2" v-if="language.count">
              {{ language.name }}
              <span class="gray3--text text-subtitle-2"
                >({{ language.count }})</span
              >
            </div>
            <div class="black--text text-subtitle-2" v-else>
              {{ language.name }}
              <span class="gray3--text text-subtitle-2">({{ total }})</span>
            </div>
          </template>
        </v-radio>
        <v-col :md="4" cols="6" class="pa-0 mt-1">
          <DialogLanguage
            :language="languageDefault"
            :languageData="golfVlogLanguage"
            @chooseLanguage="chooseLanguage"
            :totalVlog="total"
          />
        </v-col>
      </v-radio-group>
    </v-row>
  </v-card>
</template>
<script>
import DialogLanguage from "@/components/Dialog/DialogLanguage";
export default {
  name: "LanguageCard",
  props: {
    column: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Array,
      default: [],
    },
  },
  components: { DialogLanguage },
  data() {
    return {
      total: 0,
    };
  },
  computed: {
    languageDefault: {
      get() {
        return this.$store.state.post.languageDefaultVlog;
      },
      set(value) {
        this.$store.commit("post/setDefaultLanguageVlog", value);
      },
    },
    golfVlogLanguage() {
      return this.$store.state.post.golfVlogLanguage;
    },
  },
  methods: {
    async chooseLanguage(value) {
      this.languageDefault = value;
    },
  },
  async mounted() {
    this.$store.commit("post/setDefaultLanguageVlog", "all");
    const listLanguage = await this.$store.dispatch(
      "post/getLanguagePost",
      this.type
    );
    if (listLanguage) {
      this.$store.commit("post/setListLanguageVlog", listLanguage);
    }
    let vm = this;
    this.$root.$on("getTotal", function (total) {
      vm.total = total;
    });
  },
};
</script>